import { Button, Card, Modal, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import { DeleteForever } from "@mui/icons-material";

interface Props {
  isOpened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmDeleteStrategyModal = ({
  isOpened,
  onClose,
  onConfirm,
}: Props) => {
  return (
    <Modal open={isOpened} onClose={onClose}>
      <Stack height="100%" alignItems="center" justifyContent="center">
        <Box style={{ width: "600px" }}>
          <Card>
            <Typography
              variant="h5"
              component="h5"
              align="center"
              sx={{ paddingTop: 1 }}
            >
              Completely delete strategy?
            </Typography>
            <Box display="flex" justifyContent="center" sx={{ paddingX: 4, paddingY: 2 }}>
              <Typography align="center">
                This permanently removes the account strategy and its entire
                adjustment history
              </Typography>
            </Box>

            <Box display="flex">
              <Button
                startIcon={<CloseIcon />}
                fullWidth
                sx={{ marginX: 4, marginY: 1 }}
                color="primary"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                startIcon={<DeleteForever />}
                fullWidth
                sx={{ marginX: 4, marginY: 1 }}
                color="error"
                onClick={onConfirm}
              >
                Delete
              </Button>
            </Box>
          </Card>
        </Box>
      </Stack>
    </Modal>
  );
};
